app.controller('GetScheduleController', ['$scope', '$http', '$timeout', '$translate', '$compile', '$filter', function ($scope, $http, $timeout, $translate, $compile, $filter) {
	$scope.noSchedule = false;

	let now = moment();

	if ( schedule != null && now < moment(schedule.Date) ) {
		$scope.schedule = schedule;
		// $scope.schedule.AgeRestriction = true;
		// $scope.schedule.MinAge = 7;
		// $scope.schedule.MaxAge = 17;

		console.log($scope.schedule);
		$scope.gym = gym[0];
		$scope.visitProducts = $scope.schedule.Products;
		$scope.haveEquipment = true;
		$scope.fullEvent = false;
		$scope.fullEventArea = false;
		$scope.modalPrice = null;
		$scope.peopleWaiting = 0;
		$scope.waitingListApprove = false;
		$scope.ageRestrictionStatus = true;
		$scope.visitOriginalProducts = [];
		var $translateThis = $filter('translate');
		$scope.logo = logo;

		if(client){
			$scope.client = client;

			if($scope.schedule.AgeRestriction){
				checkAgeRestriction(client.Birthdate);
			}
		}

		if(WaitingListID && WaitingList){
			$scope.waitingListApprove = true;
		}

		if(!client && $scope.schedule.AgeRestriction){
			$('#birthdate').datepicker({
				changeMonth: true,
				changeYear: true,
				yearRange: "1920:2040",
				numberOfMonths: 1,
				onSelect: function (dateText, inst) {
					var date = $(this).val();

					checkAgeRestriction(date);
					$timeout(function() {
						$scope.smodal.birthdate = dateText;
					});
				}
			});
		}

		function checkAgeRestriction(date){
			let birthDate = new Date(date);
			const now = new Date();
			let age = now.getFullYear() - birthDate.getFullYear();
			const monthDiff = now.getMonth() - birthDate.getMonth();
			if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birthDate.getDate())) {
				age--;
			}

			console.log(age);

			const minAge = $scope.schedule.MinAge;
			const maxAge = $scope.schedule.MaxAge;

			$timeout(function() {
				if (minAge === 0) {
					$scope.ageRestrictionStatus = age <= maxAge;
				} else if (maxAge === 0) {
					$scope.ageRestrictionStatus = age >= minAge;
				} else {
					$scope.ageRestrictionStatus = age >= minAge && age <= maxAge;
				}
			});
		}

		$scope.phoneFormat = $scope.gym.Culture.includes('GB') ? /^[0-9\s]{5,11}$/ : /^[0-9]{5,15}$/;

		// Finding TimeZone Offset
		const timeZones = ["Europe/Andorra","Asia/Dubai","Asia/Kabul","Europe/Tirane","Asia/Yerevan","Antarctica/Casey","Antarctica/Davis","Antarctica/DumontDUrville","Antarctica/Mawson","Antarctica/Palmer","Antarctica/Rothera","Antarctica/Syowa","Antarctica/Troll","Antarctica/Vostok","America/Argentina/Buenos_Aires","America/Argentina/Cordoba","America/Argentina/Salta","America/Argentina/Jujuy","America/Argentina/Tucuman","America/Argentina/Catamarca","America/Argentina/La_Rioja","America/Argentina/San_Juan","America/Argentina/Mendoza","America/Argentina/San_Luis","America/Argentina/Rio_Gallegos","America/Argentina/Ushuaia","Pacific/Pago_Pago","Europe/Vienna","Australia/Lord_Howe","Antarctica/Macquarie","Australia/Hobart","Australia/Melbourne","Australia/Sydney","Australia/Broken_Hill","Australia/Brisbane","Australia/Lindeman","Australia/Adelaide","Australia/Darwin","Australia/Perth","Australia/Eucla","Asia/Baku","America/Barbados","Asia/Dhaka","Europe/Brussels","Europe/Sofia","Atlantic/Bermuda","Asia/Brunei","America/La_Paz","America/Noronha","America/Belem","America/Fortaleza","America/Recife","America/Araguaina","America/Maceio","America/Bahia","America/Sao_Paulo","America/Campo_Grande","America/Cuiaba","America/Santarem","America/Porto_Velho","America/Boa_Vista","America/Manaus","America/Eirunepe","America/Rio_Branco","America/Nassau","Asia/Thimphu","Europe/Minsk","America/Belize","America/St_Johns","America/Halifax","America/Glace_Bay","America/Moncton","America/Goose_Bay","America/Blanc-Sablon","America/Toronto","America/Nipigon","America/Thunder_Bay","America/Iqaluit","America/Pangnirtung","America/Atikokan","America/Winnipeg","America/Rainy_River","America/Resolute","America/Rankin_Inlet","America/Regina","America/Swift_Current","America/Edmonton","America/Cambridge_Bay","America/Yellowknife","America/Inuvik","America/Creston","America/Dawson_Creek","America/Fort_Nelson","America/Whitehorse","America/Dawson","America/Vancouver","Indian/Cocos","Europe/Zurich","Africa/Abidjan","Pacific/Rarotonga","America/Santiago","America/Punta_Arenas","Pacific/Easter","Asia/Shanghai","Asia/Urumqi","America/Bogota","America/Costa_Rica","America/Havana","Atlantic/Cape_Verde","America/Curacao","Indian/Christmas","Asia/Nicosia","Asia/Famagusta","Europe/Prague","Europe/Berlin","Europe/Copenhagen","America/Santo_Domingo","Africa/Algiers","America/Guayaquil","Pacific/Galapagos","Europe/Tallinn","Africa/Cairo","Africa/El_Aaiun","Europe/Madrid","Africa/Ceuta","Atlantic/Canary","Europe/Helsinki","Pacific/Fiji","Atlantic/Stanley","Pacific/Chuuk","Pacific/Pohnpei","Pacific/Kosrae","Atlantic/Faroe","Europe/Paris","Europe/London","Asia/Tbilisi","America/Cayenne","Africa/Accra","Europe/Gibraltar","America/Nuuk","America/Danmarkshavn","America/Scoresbysund","America/Thule","Europe/Athens","Atlantic/South_Georgia","America/Guatemala","Pacific/Guam","Africa/Bissau","America/Guyana","Asia/Hong_Kong","America/Tegucigalpa","America/Port-au-Prince","Europe/Budapest","Asia/Jakarta","Asia/Pontianak","Asia/Makassar","Asia/Jayapura","Europe/Dublin","Asia/Jerusalem","Asia/Kolkata","Indian/Chagos","Asia/Baghdad","Asia/Tehran","Atlantic/Reykjavik","Europe/Rome","America/Jamaica","Asia/Amman","Asia/Tokyo","Africa/Nairobi","Asia/Bishkek","Pacific/Tarawa","Pacific/Enderbury","Pacific/Kiritimati","Asia/Pyongyang","Asia/Seoul","Asia/Almaty","Asia/Qyzylorda","Asia/Qostanay","Asia/Aqtobe","Asia/Aqtau","Asia/Atyrau","Asia/Oral","Asia/Beirut","Asia/Colombo","Africa/Monrovia","Europe/Vilnius","Europe/Luxembourg","Europe/Riga","Africa/Tripoli","Africa/Casablanca","Europe/Monaco","Europe/Chisinau","Pacific/Majuro","Pacific/Kwajalein","Asia/Yangon","Asia/Ulaanbaatar","Asia/Hovd","Asia/Choibalsan","Asia/Macau","America/Martinique","Europe/Malta","Indian/Mauritius","Indian/Maldives","America/Mexico_City","America/Cancun","America/Merida","America/Monterrey","America/Matamoros","America/Mazatlan","America/Chihuahua","America/Ojinaga","America/Hermosillo","America/Tijuana","America/Bahia_Banderas","Asia/Kuala_Lumpur","Asia/Kuching","Africa/Maputo","Africa/Windhoek","Pacific/Noumea","Pacific/Norfolk","Africa/Lagos","America/Managua","Europe/Amsterdam","Europe/Oslo","Asia/Kathmandu","Pacific/Nauru","Pacific/Niue","Pacific/Auckland","Pacific/Chatham","America/Panama","America/Lima","Pacific/Tahiti","Pacific/Marquesas","Pacific/Gambier","Pacific/Port_Moresby","Pacific/Bougainville","Asia/Manila","Asia/Karachi","Europe/Warsaw","America/Miquelon","Pacific/Pitcairn","America/Puerto_Rico","Asia/Gaza","Asia/Hebron","Europe/Lisbon","Atlantic/Madeira","Atlantic/Azores","Pacific/Palau","America/Asuncion","Asia/Qatar","Indian/Reunion","Europe/Bucharest","Europe/Belgrade","Europe/Kaliningrad","Europe/Moscow","Europe/Simferopol","Europe/Kirov","Europe/Volgograd","Europe/Astrakhan","Europe/Saratov","Europe/Ulyanovsk","Europe/Samara","Asia/Yekaterinburg","Asia/Omsk","Asia/Novosibirsk","Asia/Barnaul","Asia/Tomsk","Asia/Novokuznetsk","Asia/Krasnoyarsk","Asia/Irkutsk","Asia/Chita","Asia/Yakutsk","Asia/Khandyga","Asia/Vladivostok","Asia/Ust-Nera","Asia/Magadan","Asia/Sakhalin","Asia/Srednekolymsk","Asia/Kamchatka","Asia/Anadyr","Asia/Riyadh","Pacific/Guadalcanal","Indian/Mahe","Africa/Khartoum","Europe/Stockholm","Asia/Singapore","America/Paramaribo","Africa/Juba","Africa/Sao_Tome","America/El_Salvador","Asia/Damascus","America/Grand_Turk","Africa/Ndjamena","Indian/Kerguelen","Asia/Bangkok","Asia/Dushanbe","Pacific/Fakaofo","Asia/Dili","Asia/Ashgabat","Africa/Tunis","Pacific/Tongatapu","Europe/Istanbul","America/Port_of_Spain","Pacific/Funafuti","Asia/Taipei","Europe/Kiev","Europe/Uzhgorod","Europe/Zaporozhye","Pacific/Wake","America/New_York","America/Detroit","America/Kentucky/Louisville","America/Kentucky/Monticello","America/Indiana/Indianapolis","America/Indiana/Vincennes","America/Indiana/Winamac","America/Indiana/Marengo","America/Indiana/Petersburg","America/Indiana/Vevay","America/Chicago","America/Indiana/Tell_City","America/Indiana/Knox","America/Menominee","America/North_Dakota/Center","America/North_Dakota/New_Salem","America/North_Dakota/Beulah","America/Denver","America/Boise","America/Phoenix","America/Los_Angeles","America/Anchorage","America/Juneau","America/Sitka","America/Metlakatla","America/Yakutat","America/Nome","America/Adak","Pacific/Honolulu","America/Montevideo","Asia/Samarkand","Asia/Tashkent","America/Caracas","Asia/Ho_Chi_Minh","Pacific/Efate","Pacific/Wallis","Pacific/Apia","Africa/Johannesburg","America/Antigua","America/Anguilla","Africa/Luanda","Antarctica/McMurdo","America/Aruba","Europe/Mariehamn","Europe/Sarajevo","Africa/Ouagadougou","Asia/Bahrain","Africa/Bujumbura","Africa/Porto-Novo","America/St_Barthelemy","America/Kralendijk","Africa/Gaborone","Africa/Kinshasa","Africa/Lubumbashi","Africa/Bangui","Africa/Brazzaville","Africa/Douala","Europe/Busingen","Africa/Djibouti","America/Dominica","Africa/Asmara","Africa/Addis_Ababa","Africa/Libreville","America/Grenada","Europe/Guernsey","Africa/Banjul","Africa/Conakry","America/Guadeloupe","Africa/Malabo","Europe/Zagreb","Europe/Isle_of_Man","Europe/Jersey","Asia/Phnom_Penh","Indian/Comoro","America/St_Kitts","Asia/Kuwait","America/Cayman","Asia/Vientiane","America/St_Lucia","Europe/Vaduz","Africa/Maseru","Europe/Podgorica","America/Marigot","Indian/Antananarivo","Europe/Skopje","Africa/Bamako","Pacific/Saipan","Africa/Nouakchott","America/Montserrat","Africa/Blantyre","Africa/Niamey","Asia/Muscat","Africa/Kigali","Atlantic/St_Helena","Europe/Ljubljana","Arctic/Longyearbyen","Europe/Bratislava","Africa/Freetown","Europe/San_Marino","Africa/Dakar","Africa/Mogadishu","America/Lower_Princes","Africa/Mbabane","Africa/Lome","Africa/Dar_es_Salaam","Africa/Kampala","Pacific/Midway","Europe/Vatican","America/St_Vincent","America/Tortola","America/St_Thomas","Asia/Aden","Indian/Mayotte","Africa/Lusaka","Africa/Harare" ]

		let timezoneP = timeZone.split(') ');
		let timezonePi = timezoneP[1].split(',');
		let timeZoneC = timezonePi[0];
		let timeZoneF = timeZones.find(el => el.includes(timeZoneC)); 

		let timeZoneOffsetSplit = timezoneP[0].split('UTC');
		$scope.timeZoneOffset = timeZoneOffsetSplit[1];

		// console.log($scope.infoData.TimeZoneKey);
		// console.log(timeZoneC);
		// console.log(timeZoneF);

		moment.tz.setDefault(timeZoneF);

		// check for Max Area People

		let dataObject = {
			ScheduleContentID: schedule.ID,
			GymID: gymid,
			Namespace: namespace
		}

		$http({
			method: 'POST',
			url: '/private/CheckMaxPeopleAreaReached',
			data: dataObject
		}).success(function (data) {

			if( data == 0 ){
				if( schedule.PeopleAttending >= schedule.MaxClients){
					$scope.fullEvent = true;
				}else{
		
					// CheckForWaitingPeople(int ScheduleContentID, int GymID, string Namespace)
					let dataObject = {
						ScheduleContentID: schedule.ID,
						GymID: gymid,
						Namespace: namespace
					}
					$http({
						method: 'POST',
						url: '/private/CheckForWaitingPeople',
						data: dataObject
					}).success(function (data) {
						if( $scope.waitingListApprove && data >= 1){
							$scope.peopleWaiting = 0;
						}else{
							$scope.peopleWaiting = data;
						}
					}).error(function (error) {
					});
				}
			}else{
				$scope.fullEventArea = true;
			}

		}).error(function (error) {
		});

		$scope.smodal = {paymentMethod: null, email: ''};

		if (lang){
			lang = lang;	
		}else{
			if ($scope.gym.Culture.includes('-ES') ) {
				if ($scope.gym.Culture == 'ca-ES' || $scope.gym.Culture == 'ca-ES-valencia') {
					lang = 'esc';	
				}else if($scope.gym.Culture == 'es-MX'){
					lang = 'esm';	
				}else{
					lang = 'es';
				}
			}else if ($scope.gym.Culture == 'bg-BG'){
				lang = 'bg';
			}else if ($scope.gym.Culture == 'pt-PT'){
				lang = 'pt';
			}else if ($scope.gym.Culture == 'it-IT'){
				lang = 'it';
			}else if ($scope.gym.Culture == 'ro-RO'){
				lang = 'ro';
			}else if ($scope.gym.Culture == 'lt-LT'){
				lang = 'lt';
			}else if ($scope.gym.Culture == 'id-ID'){
				lang = 'id';
			}else if ($scope.gym.Culture == 'de-DE'){
				lang = 'de';
			}else if ($scope.gym.Culture == 'mk-MK'){
				lang = 'mk';
			}else{
				lang = 'en';	
			}
		}

		$translate.use(lang)

		var DateNewDate = moment($scope.schedule['Date']);
		var DateNewDateEnd = moment($scope.schedule['DateEnd']);

		var isDstChangeDay = moment(DateNewDate).isDST();
		if ( isDstChangeDay ){
			DateNewDate = moment(DateNewDate).add(1, 'hours');
			DateNewDateEnd = moment(DateNewDateEnd).add(1, 'hours');
		}

		var convertedDate = DateNewDate.toString();
		var convertedDateEnd = DateNewDateEnd.toString();

		$scope.schedule['NewDate'] = moment(convertedDate).toDate();
		$scope.schedule['NewDateEnd'] = moment(convertedDateEnd).toDate();

		$scope.people = [];
		$scope.noSlotsLeft = false;


		var dayOfWeek = $filter('date')($scope.schedule.NewDate, 'EEEE');
		var compiledeHTML = $compile("<span translate-date-object-schedule><span class='day ng-binding'>" + dayOfWeek + "</span></span>")($scope);
		$(".dayofweekn").html(compiledeHTML);

	    $scope.getSettings = function (id) {
			var dataObject = {
			    Namespace: namespace,
			    GymID: gymid
			}
			$http({
				method: 'POST',
				url: '/ScheduleV2/GetSettings',
				data: dataObject
			}).success(function (data) {
				console.log(data);
				window.membershipCurrencyCode = data.CurrencyCode;
				$scope.classSettings = data;
			}).error(function () {
				// console.log('error');
			});
		}

		$scope.getSettings();


		// $scope.updateVisitProduct = function(id){
		// 	if ( id != '-1' ) {
		// 		var result = $.grep($scope.visitProducts, function (e) { return e.ProductID == id });
		// 		$scope.productId = id;
		// 		$scope.productName = result[0].ProductName;
		// 	}else{
		// 		$scope.productId = '-1';
		// 		$scope.productName = 'Own equipment'
		// 	}
		// }

		// public bool RemoveFromWaitingList(int ID, int GymID, string Namespace)

		$scope.cancelRequest = function(){
			let translated = $translateThis('Are you sure you want to cancel your request');
			Swal.fire({
				type: 'warning',
				title: translated,
				showCancelButton: true,
				confirmButtonText: 'Yes!'
			}).then((result) => {
				if (result.value) {
					removeFromWaitingList();
				}
			});
		}

		function removeFromWaitingList(){
			let dataObject = {
				ID: WaitingListID,
				GymID: gymid,
				Namespace: namespace
			}
			$http({
				method: 'POST',
				url: '/private/RemoveFromWaitingList',
				data: dataObject
			}).success(function (data) {
				console.log(data);
				let result = JSON.parse(data.toLowerCase());

				if(result){
					let translated = $translateThis('You are removed!');

					Swal.fire({
						type: 'success',
						title: translated,
					});
				}else{
					let translated = $translateThis('Error');

					Swal.fire({
						type: 'error',
						title: translated,
					});
				}
			}).error(function (error) {})

		}

		$scope.updateVisitProduct = function(item){
			if (item.productName && item.productName != 'Own equipment') {
				var result = $.grep($scope.visitProducts, function (e) { return e.ProductName == item.productName });
				result[0].ItemsLeft = ++result[0].ItemsLeft;
			}
	
			if ( item.productId != '-1' ) {
				var result = $.grep($scope.visitProducts, function (e) { return e.ProductID == item.productId });
				item.productName = result[0].ProductName;
				item.productItemsLeft = result[0].ItemsLeft;
				result[0].ItemsLeft = --result[0].ItemsLeft;
			}else{
				item.productName = 'Own equipment'
			}
	
			return item;
		}

		function getEventPrice() {
			var dataObject = {
				Namespace: namespace,
				GymID: gymid,
				id: $scope.PublicEventID,
			}
			
			$http({
				method: 'GET',
				url: '/private/GetPublicEventPrice?Namespace=' + namespace + '&GymID=' + gymid + '&id=' + $scope.PublicEventID,
				data: dataObject
			}).success(function (data) {
				$scope.modalPrice = data;
				calculateEventPrice();

				// Check if there is only one payment method
				if( $('.shcedule-popup .form-field.field-payments .dd-field:visible').length ==  1){
					// And trigger the hell out of it!
					$('.shcedule-popup .form-field.field-payments .dd-field:visible').trigger('click').find('label').trigger('click');
					$('.shcedule-popup .form-field.field-payments .dd-field:visible input').prop('checked', true);
					let paymentNumber = $('.shcedule-popup .form-field.field-payments .dd-field:visible input').val();
					$timeout(function() {
						$scope.smodal.paymentMethod = paymentNumber;
						$scope.paymentChange();
					}, 10);
				}
			}).error(function () {
			});
		}

		$scope.paymentChange = function(){
			if ($scope.smodal.paymentMethod == '7' && $scope.modalPrice > 0) {

				generatePaymentIntent()

			}else{
				$('.form-actions .button.stripe-button').removeClass('show');
			}
		}
	
		// Generate PaymentInted for Stripe
		function generatePaymentIntent() {
			$scope.PaymentIntentID = 0;
			let dataObject = prepareDataToSned();
	
			if ($scope.formLoaded == true) {
				$scope.formLoaded = false;
				$scope.loading = true;
				$http({
					method: 'POST',
					url: '/private/GeneratePaymentIntent',
					data: dataObject
				}).success(function (data) {

					if(data == 'Waiver Required!'){
						var translated = $translateThis('Waiver Required!Portal');
						var waiverHref = window.location.origin + '/waiver/embedregistration?GymID=' + gymid + '&NameSpace=' + namespace + '&Redirect=/Schedulev2/EmbedGroupSchedulev2';
						Swal.fire({
							type: 'warning',
							title: translated,
							showCancelButton: true,
						}).then(function(result) {
							if (result.value) {
								window.location.href = waiverHref;
							}else{
								$timeout(function() {
									$scope.formLoaded = true;
									$scope.loading = false;
								}, 1);
							}
						});
					}else if(data == 'Customer banned from booking!'){
						let translated = $translateThis('Your access to the booking system has been suspended due to non-compliance with the rules of the sports center. Please contact reception.');
						Swal.fire({
							type: 'warning',
							title: translated
						});
						$scope.formLoaded = true;
						$scope.loading = false;
					}else if( data == 2 ){
						let translated = $translateThis(joinEventResponses[data]);
						Swal.fire({
							type: 'warning',
							title: translated
						});
						$scope.formLoaded = true;
						$scope.loading = false;
					}else{
						// stripeConfirmCard(data);
						stripeInitialize(data);
						$scope.BookingOrderID = data.BookingOrderID;
						$scope.PaymentIntentID = data.ID;
						$scope.formLoaded = true;
					}
				}).error(function (error) {
					let translated = $translateThis('ERROR');
					Swal.fire({
						type: 'warning',
						title: translated
					});
					$scope.formLoaded = true;
					$scope.loading = false;
				});
			}
		}

		function stripeInitialize(data){
			$scope.stripe = Stripe($scope.classSettings.StripePublishKey, {
				betas: ['mb_way_pm_beta_1'],
			});
			
			const options = {
				clientSecret: data.ClientSecret,
				appearance: {/*...*/},
			};

			let clientName;
			if($scope.client){
				clientName = $scope.client.FirstName + ' ' + $scope.client.LastName;
			}else{
				clientName = $scope.scheduleFirstName + ' ' + $scope.scheduleLastName;
			}

			$scope.stripeElements = $scope.stripe.elements(options);
			$scope.stripeError = document.getElementById('error-message');
			const paymentElementOptions = { 
				layout: 'accordion',
				defaultValues: {
					billingDetails: {
						name: clientName,
						email: 'never',
                    	phone: 'never'
					}
				}
			};
			const paymentElement = $scope.stripeElements.create('payment', paymentElementOptions);
			paymentElement.mount('#payment-element');
			$scope.loading = false;
		}

		function stripeConfirmPayment(){
			if (!$scope.stripe || !$scope.stripeElements) return;
			$scope.loading = true;

			$scope.stripe.confirmPayment({
				elements: $scope.stripeElements,
				redirect: 'if_required',
			}).then(function(result) {
				var error = result.error;
				var paymentIntent = result.paymentIntent;

				console.log(result);

				if (error) {
					$timeout(function() {
						$scope.loading = false;
						if ($scope.stripeError) $scope.stripeError.textContent = error.message;
					});
				} else {
					switch (paymentIntent.status) {
					case 'succeeded':
						// $scope.placeOrder(true);
						$scope.joinEvent();
						break;
					case 'requires_payment_method':
						$timeout(function() {
							$scope.loading = false;
							var msg = (paymentIntent.last_payment_error && paymentIntent.last_payment_error.message)
								? paymentIntent.last_payment_error.message
								: 'Payment failed. Please try another payment method.';
							var translatedMsg = $translateThis(msg);
							if ($scope.stripeError) $scope.stripeError.textContent = translatedMsg;
							Swal.fire({ type: 'warning', title: translatedMsg });
						});
						break;
					default:
						$timeout(function() {
							$scope.loading = false;
						});
						break;
					}
				}
			});
		}
	
		function prepareDataToSned(){
			
			let dataObject = {
				Namespace: namespace,
				GymID: gymid,
				Id: $scope.schedule.ID,
				Email: $scope.client ? $scope.client.Email : $scope.smodal.email,
				Date: moment($scope.schedule.NewDate).toISOString(),
				VisitName: $scope.schedule.VisitName,
				PaymentMethod: $scope.smodal.paymentMethod,
				Language: lang,
				ProductID: $scope.productId,
				ProductName: $scope.productName,
				AdditionalGuests: $scope.people,
				PaymentIntentID: $scope.PaymentIntentID,
				receiveEmails: $scope.smodal.MarketingEmailsClassBooking
			}
	
			if ( $scope.classSettings.ClassBookingRequireProfile != true ) {
				let tel;
				tel = $scope.inputPhone.selectedDialCode.innerHTML + $scope.inputPhone.telInput.value;
				tel = tel.replace(/ /g,'');
	
				dataObject.FirstName = $scope.client ? $scope.client.FirstName : $scope.scheduleFirstName;
				dataObject.LastName = $scope.client ? $scope.client.LastName : $scope.scheduleLastName;
				dataObject.Telephone = $scope.client ? $scope.client.Telephone : tel;
			}
	
			if ( $scope.smodal.paymentMethod == '7' ) {
				dataObject.Price = $scope.totalPrice;
				dataObject.PublicEventID = $scope.PublicEventID;
				dataObject.OrderID = $scope.BookingOrderID
			}

			if ($scope.smodal.paymentMethod == '8') {
				dataObject.PaymentMethod = 8;
				dataObject.Price = $scope.modalPrice;
				dataObject.PublicEventID = $scope.PublicEventID;
			}

			if ($scope.smodal.paymentMethod == '9') {
				dataObject.PaymentMethod = 9;
				dataObject.Price = $scope.modalPrice;
				dataObject.PublicEventID = $scope.PublicEventID;
			}
	
			return dataObject;
		}


		$scope.PublicEventID = $scope.schedule.PublicEventID;
		$scope.noSlotsLeft = $scope.schedule.SlotsLeft > 1 ? false : true;

		function calculateEventPrice(){
			if ( $scope.people.length > 0 ) {
				$scope.additionPrice = $scope.people.length*parseFloat($scope.modalPrice);
				$scope.totalPrice = (parseFloat($scope.additionPrice) + parseFloat($scope.modalPrice)).toFixed(4);
			}else{
				$scope.totalPrice = $scope.modalPrice;
			}
	
			$scope.noSlotsLeft = $scope.schedule.SlotsLeft > $scope.people.length + 1 ? false : true;
		}

		getEventPrice();

		function checkEqipment(){	
			let bookedPeople = [...$scope.people];
	
			if(bookedPeople){
				bookedPeople.push({productId: $scope.smodal.productId})
				let group = bookedPeople.reduce((r, a) => {
					r[a.productId] = [...r[a.productId] || [], a];
					return r;
				}, {});
	
				for (var key in group) {
					if(key > 0){
						let item = $scope.visitOriginalProducts.find((item) => item.ProductID == key);
						if( item.ItemsLeft >= group[key].length){
							$scope.haveEquipment = true;
						}else{
							$scope.haveEquipment = false;
							break;
						}
					}else{
						$scope.haveEquipment = true;
					}
				}
			}else{
				let item = $scope.visitOriginalProducts.find((item) => item.ProductID == $scope.smodal.productId);
				if(item.ItemsLeft>0){
					$scope.haveEquipment = true;
				}else{
					$scope.haveEquipment = false;
				}
			}

			if($scope.haveEquipment){
				sendJoinEventRequest();
			}
		}

		function getEqipment(final = false){
			var dataObject = {
				Namespace: namespace,
				GymID: gymid,
				ID: $scope.schedule.ID
			}
	
			$http({
				method: 'GET',
				url: '/api/public/GetEqipment?nameSpace=' + namespace + '&gymId=' + gymid + '&ID=' + $scope.schedule.ID,
				data: dataObject
			}).success(function (data) {
				if($scope.visitProducts.length == 0){
					$scope.visitProducts = data;
				}
				$scope.visitOriginalProducts = [...data];
				$scope.modalLoading = false;
				if(final)
					checkEqipment();
			}).error(function () {
	
			});
		}

		getEqipment();

		// Join Event
		$scope.formLoaded = true;

		var joinEventResponses = new Array('joinEventResponse1', 'joinEventResponse2', 'joinEventResponse3', 'joinEventResponse4', 'joinEventResponse5', 'joinEventResponse6', 'joinEventResponse7', 'joinEventResponseEmpty','joinEventResponseEmpty', 'joinEventResponse8', 'joinEventResponse9', 'joinEventResponse10');

		function sendJoinEventRequest(){

			if($scope.waitingListApprove && ($scope.smodal.paymentMethod == 1 || $scope.smodal.paymentMethod == 7)){
				standardJoinEvent();
			}else if($scope.waitingListApprove && ($scope.smodal.paymentMethod == 0 || $scope.smodal.paymentMethod == 2 || $scope.smodal.paymentMethod == 3 || $scope.smodal.paymentMethod == 4 || $scope.smodal.paymentMethod == 5 || $scope.smodal.paymentMethod == 6)){
				approveFromWaitingList();
			}else{
				standardJoinEvent();
			}
		}

		// ApproveFromWaitingList(string Email, string Language, int ID, int GymID, string Namespace)

		function approveFromWaitingList(){
			$scope.loading = true;
			let dataObject = {
				ID: WaitingListID,
				Namespace: namespace,
				GymID: gymid,
				Email: $scope.client ? $scope.client.Email : $scope.smodal.email,
				Language: lang
			}

			$http({
				method: 'POST',
				url: '/private/ApproveFromWaitingList',
				data: dataObject
			}).success(function (data) {
				let result = JSON.parse(data.toLowerCase());

				if(result){
					$scope.joinEventResponse = joinEventResponses[0];
					let translated = $translateThis($scope.joinEventResponse);
					Swal.fire({
						type: 'success',
						title: translated
					});

					// $('.box-single .success-msg').addClass('green');
				}else{
					$scope.joinEventResponse = joinEventResponses[2];
					// $('.box-single .success-msg').addClass('red');

					let translated = $translateThis($scope.joinEventResponse);
					Swal.fire({
						type: 'warning',
						title: translated
					});
				}
				$scope.loading = false;
			}).error(function () {
				$scope.loading = false;
			});
		}

		function standardJoinEvent(){
			let dataObject = prepareDataToSned();
			if ($scope.formLoaded == true) {
			    $scope.formLoaded = false;
			    $http({
			        method: 'POST',
			        url: '/private/JoinEvent',
			        data: dataObject
			    }).success(function (data) {
			        var responseI = data;
			        $scope.joinEventResponse = joinEventResponses[responseI];

					if (responseI == 0) {
						if (dataObject.PaymentMethod == 8) {
							generateMyPos();
						}else if (dataObject.PaymentMethod == 9) {
							generatePaymob();
						}else if (dataObject.PaymentMethod == 12) {
							generateCpay();
						}else if (dataObject.PaymentMethod == 13) {
							generateXendit();
						}else{
							let translated = $translateThis($scope.joinEventResponse);
							Swal.fire({
								type: 'success',
								title: translated,
								onAfterClose: () => $scope.closePopup()
							});
							$scope.loading = false;
						}
						
					}else if(responseI == 1) {
						$scope.fullEvent = true;
						$scope.loading = false;
						// $('#waitingModal').modal('show');
						// $('#waiting-popup .popup, #waiting-popup').addClass('show');
					}else if(responseI == 6) {
						let translated = $translateThis($scope.joinEventResponse);
						Swal.fire({
							type: 'warning',
							title: translated,
						});
						$scope.loading = false;
					}else if(responseI == 8){
						var translated = $translateThis('Waiver Required!Portal');
						var waiverHref = window.location.origin + '/waiver/embedregistration?GymID=' + gymid + '&NameSpace=' + namespace + '&Redirect=/Schedulev2/EmbedGroupSchedulev2';
						Swal.fire({
							type: 'warning',
							title: translated,
							showCancelButton: true,
						}).then(function(result) {
							if (result.value) {
								window.location.href = waiverHref;
							}else{
								$timeout(function() {
									$scope.formLoaded = true;
									$scope.loading = false;
								}, 1);
							}
						});
					}else if(responseI == 9) {
						let maxResPerDay = $scope.classSettings.MaxReservationsPerDay;
						let translated = $translateThis($scope.joinEventResponse, {value: maxResPerDay});
	
						Swal.fire({
							type: 'warning',
							title: translated,
						});
						$scope.loading = false;
					}else{
						let translated = $translateThis($scope.joinEventResponse);
						Swal.fire({
							type: 'warning',
							title: translated
						});
	
						$scope.formLoaded = true;
						$scope.loading = false;
					}

					
			        // if (responseI == 0) {
					// 	let translated = $translateThis($scope.joinEventResponse);
					// 	Swal.fire({
					// 		type: 'success',
					// 		title: translated
					// 	});

			        //     // $('.box-single .success-msg').addClass('green');
			        // }else if(responseI == 1) {
					// 	// $scope.joinWaitingList($scope.modalVisit);
					// 	$scope.fullEvent = true;
					// 	// $('#waiting-popup .popup, #waiting-popup').addClass('show');
					// }else if (responseI == 6) {
					// 	let translated = $translateThis($scope.joinEventResponse);
					// 	Swal.fire({
					// 		type: 'warning',
					// 		title: translated
					// 	});
			        // }
					
			        $scope.formLoaded = true;
					// $scope.loading = false;
			    }).error(function () {
					let translated = $translateThis('ERROR');
					Swal.fire({
						type: 'warning',
						title: translated
					});

			        // $('.box-single .error-msg').addClass('show');
			        $scope.formLoaded = true;
					$scope.loading = false;
			    });
			}
		}

		function generatePaymob(){

			let dataObject = prepareDataToSned();
			dataObject.Language = lang;
			
			$http({
				method: 'POST',
				url: '/private/GeneratePaymobURL',
				data: dataObject
			}).success(function (data) {
				if(data != 'Error'){
					let paymoblink = data;
                	window.location.href = paymoblink;
				}else{
					let translated = $translateThis('ERROR');
					Swal.fire({
						type: 'warning',
						title: translated,
					});

					$scope.formLoaded = true;
					$scope.loading = false;
				}
				console.log(data);
			}).error(function (error) {
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated,
				});
	
				$scope.formLoaded = true;
				$scope.loading = false;
			});
		}

		function generateCpay(){

			let dataObject = prepareDataToSned();
			dataObject.Language = lang;
			
			$http({
				method: 'POST',
				url: '/private/GenerateCPayValues',
				data: dataObject
			}).success(function (data) {
				if(data != 'Error'){
					post_to_url(data, 'post', data.PaymentUrl);
				}else{
					let translated = $translateThis('ERROR');
					Swal.fire({
						type: 'warning',
						title: translated,
					});

					$scope.formLoaded = true;
					$scope.loading = false;
				}
				console.log(data);
			}).error(function (error) {
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated,
				});
	
				$scope.formLoaded = true;
				$scope.loading = false;
			});
		}

		function generateXendit(){
			let dataObject = prepareDataToSned();
			dataObject.Language = lang;
			
			$http({
				method: 'POST',
				url: '/private/GenerateXenditValues',
				data: dataObject
			}).success(function (data) {
				if(data.IsSuccess == true){
					window.location.href = data.PaymentLinkUrl;
				}else{
					let translated = $translateThis('ERROR');
					Swal.fire({
						type: 'warning',
						title: data.ErrorMessage,
					});

					$scope.formLoaded = true;
					$scope.loading = false;
				}
				console.log(data);
			}).error(function (error) {
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated,
				});
	
				$scope.formLoaded = true;
				$scope.loading = false;
			});
		}

		function generateMyPos(){

			let dataObject = prepareDataToSned();
			dataObject.Language = lang;
			
			$http({
				method: 'POST',
				url: '/private/GenerateMyPosValues',
				data: dataObject
			}).success(function (data) {
				if(data != 'Error'){
					post_to_url(data, 'post');
				}else{
					let translated = $translateThis('ERROR');
					Swal.fire({
						type: 'warning',
						title: translated,
					});

					$scope.formLoaded = true;
					$scope.loading = false;
				}
				console.log(data);
			}).error(function (error) {
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated,
				});
	
				$scope.formLoaded = true;
				$scope.loading = false;
			});
		}

		function post_to_url(params, method, url) {
			let path = $scope.classSettings.MyPosTestingMode ? 'https://www.mypos.com/vmp/checkout-test' : 'https://www.mypos.com/vmp/checkout';
			if(url){
				path = url;
			}
			method = method || "post";
		
			var form = document.createElement("form");
			form.setAttribute("method", method);
			form.setAttribute("action", path);
		
			for(var key in params) {
				if(params.hasOwnProperty(key)) {
					var hiddenField = document.createElement("input");
					hiddenField.setAttribute("type", "hidden");
					hiddenField.setAttribute("name", key);
					hiddenField.setAttribute("value", params[key]);
		
					form.appendChild(hiddenField);
				 }
			}
		
			document.body.appendChild(form);
			form.submit();
		}

		$scope.linkjoinEvent = function(){
			if( $scope.modalPrice != null && $scope.modalPrice != undefined && Number($scope.modalPrice).toFixed(2) == 0.00){
				$scope.smodal.paymentMethod = '0';
				$scope.joinEvent();
			}else{
				if ($scope.smodal.paymentMethod == '7') {
					stripeConfirmPayment()
				}else{
					$scope.joinEvent();
				}
			}
		}

		$scope.joinEvent = function () {
			getEqipment(true);
		}

		$scope.joinWaitingList = function(event){
			let dataObject = {
				Namespace: namespace,
				GymID: gymid,
				Id: event.ID,
				Email: $scope.client ? $scope.client.Email : $scope.waitingList.Email,
				Date: moment(event.NewDate).toISOString(),
				VisitName: event.VisitName,
				Language: lang
			}
	
			if ( $scope.client ) {
				dataObject.FirstName = $scope.client.FirstName;
				dataObject.LastName = $scope.client.LastName;
				dataObject.Telephone = $scope.client.Telephone;
			}

	
			$http({
				method: 'POST',
				url: '/private/JoinWaitingList',
				data: dataObject
			}).success(function (data) {
	
				//0:everything ok; 1:no client found; 2:cannot add to waiting list; 3:error;4 already in the same waiting list; 7:no event found
	
				console.log(data);
				let response = data;
	
				if(response == 0){
					let translated = $translateThis('Thank you for joining the waitlist. You will receive an email if space becomes available.');
					Swal.fire({
						type: 'success',
						title: translated,
					});
				}else if(response == 1){
					let translated = $translateThis('There is no customer with this email. Please contact reception.');
					Swal.fire({
						type: 'warning',
						title: translated,
					});
				}else if(response == 2){
					let translated = $translateThis('Cannot add to waiting list');
					Swal.fire({
						type: 'warning',
						title: translated,
					});
				}else if(response == 3){
					let translated = $translateThis('Error');
					Swal.fire({
						type: 'warning',
						title: translated,
					});
				}else if(response == 4){
					let translated = $translateThis('You are already in the waitlist. We will send you an email if space becomes available');
					Swal.fire({
						type: 'warning',
						title: translated,
					});
				}else if(response == 7){
					let translated = $translateThis('no event found');
					Swal.fire({
						type: 'warning',
						title: translated,
					});
				}
			}).error(function (error) {
			});
		}

		$scope.addPerson = function(){
			let person = {};
			$scope.people.push(person);
			calculateEventPrice();
		}
	
		$scope.deletePerson = function(index){
			let item = $scope.people[index];
	
			if (item.productId > -1) {
				let result = $.grep($scope.visitProducts, function (e) { return e.ProductID == item.productId });
				result[0].ItemsLeft = ++result[0].ItemsLeft;
			}
			$scope.people.splice(index,1);
			calculateEventPrice();
		}

		$(document).on('click', '.dd .dd-head', function (e) {
			$(this).parent('.dd').toggleClass('show');
		});

		$(document).click(function (e) {
			if ($(e.target).closest('.dd').length === 0 && $('.dd').is('.show')) {
				$('.dd').removeClass('show');
			}
		});

		$(document).on('click', '.box-single .dd-field', function () {
			var content = $(this).find('label').html();
			var dd = $(this).parents('.dd');
			dd.find('.dd-head').html(content);
			dd.removeClass('show');
			$scope.paymentChange();
		})

		if (gym) {
			if (gym[0].PortalColor != null && gym[0].PortalColor != 'default') {
				$('.schedule-wrapper').addClass('theme-' + gym[0].PortalColor);
			}
		}

		$(window)
			.on('load', function () {

				let phoneLang = getLanguage($scope.gym.Culture);
				var inputInitPhone = document.querySelector("#popuptelephone");
				
				if(inputInitPhone){

					if($scope.gym.Culture.includes('GB')){
						$('#popuptelephone')
						.on('keydown', function (e) {
							if(e.keyCode == 32){
								return false;
							}
						})
						.on('keyup', function (e) {
							if(e.target.value.length == 4){
								e.target.value = e.target.value += ' ';
							}
						});
					}

					$scope.inputPhone = window.intlTelInput(inputInitPhone, {
						autoHideDialCode: false,
						preferredCountries: [phoneLang],
						separateDialCode: true
					});

					inputInitPhone.addEventListener("countrychange", function() {
						let countryinfo = $scope.inputPhone.getSelectedCountryData()
						if(countryinfo.dialCode == '44'){
							inputInitPhone.value = inputInitPhone.value.split(' ').join('');
							if(inputInitPhone.value.length > 4){
								inputInitPhone.value = inputInitPhone.value.substring(0, 4) + " " + inputInitPhone.value.substring(4, 10);
							}
							$scope.phoneFormat = /^[0-9\s]{5,11}$/;
							$('#popuptelephone')
							.on('keydown', function (e) {
								if(e.keyCode == 32){
									return false;
								}
							})
							.on('keyup', function (e) {
								if(e.target.value.length == 4){
									e.target.value = e.target.value += ' ';
								}
							});
						}else{
							inputInitPhone.value = inputInitPhone.value.split(' ').join('');
							$scope.phoneFormat = /^[0-9]{5,15}$/;
							$scope.waiverForm.Telephone.$validate()
							$('#popuptelephone')
							.on('keydown', function (e) {
								if(e.keyCode == 32){
									return false;
								}
							})
							.on('keyup', function (e) {
								if(e.target.value.length == 4){
									// e.target.value = e.target.value += ' ';
								}
							});
						}
					});
				}
			})

		// Get Language from backend settings
		function getLanguage(culture){
			let lang = culture.split('-');
			lang = lang[1].toLowerCase();
			return lang;
		}
		
	}else{
		$scope.noSchedule = true;
	}
}]);